import React from 'react';
import { Link } from 'react-router-dom';
import './Home.css';

const Home = () => {
    return (
        <div className="home-container">
            <div className="main-content">
                <div className="header-section">
                    <div className="logo-section">
                        <img src="/com-service-logo.png" alt="COM Service Logo" className="logo" />
                        {/* <div className="company-text">
                            <h1>COM Service</h1>
                            <p>Service, maintenance and<br />engineering for<br />automated systems</p>
                        </div> */}
                    </div>
                    <div className="company-info">
                        <h2>COM Service Soc. Coop. A R.L.</h2>
                        <p>Iscrizione Albo Società Cooperative N. C103084</p>
                        <p>Via Isonzo, Nr 6/B</p>
                        <p>IT-22078 Turate (CO)</p>
                        <p>TEL. +39 02 96753044</p>
                        <p>FAX +39 02 96753045</p>
                        <p>E-mail: <a href="mailto:info@com-service.biz">info@com-service.biz</a></p>
                        <p>E-mail PEC: <a href="mailto:com_service1@legalmail.it">com_service1@legalmail.it</a></p>
                    </div>
                </div>

                <div className="details-section">
                    <div className="detail-item">
                        <strong>VAT IT</strong> 03535800134<br />
                        <strong>EORI N</strong> 03535800134<br />
                        <strong>Numero REA</strong> CO-32019
                    </div>

                    <div className="detail-item">
                        <strong>Fatturazione Elettronica</strong><br />
                        Codice Univoco M5UXCR1
                    </div>

                    <div className="detail-item">
                        <strong>Coordinate bancarie:</strong><br />
                        BCC di Busto Garolfo e Buguggiate SC - Filiale di Varese Biumo –<br />
                        IBAN IT 71 L 08404 10802 000000242021 <br /> BIC ICRAITRRB80
                        <br />&nbsp;<br />
                        Intesa San Paolo S.p.a Filiale di Rovellasca (CO)<br />
                        IBAN IT 12 M 03069 51730 100000002114 <br /> BIC BCITITMM
                    </div>
                </div>

                <div className="contacts-section">
                    <div className="contact-item">
                        <strong>Administration & Finance:</strong><br />
                        Francesca Mastroserio &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <a href="mailto:f.mastroserio@com-service.biz">f.mastroserio@com-service.biz</a><br />
                        TEL. Diretto +39 02 96753049<br />
                        Cell. +39 346 50 95 950
                    </div>

                    <div className="contact-item">
                        <strong>Technical Sales & Service Manager:</strong><br />
                        Gaetano Cigna &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <a href="mailto:g.cigna@com-service.biz">g.cigna@com-service.biz</a><br />
                        TEL. Diretto +39 02 96753047<br />
                        Cell. +39 347 84 09 805
                    </div>

                    <div className="contact-item">
                        <strong>Technical Sales & Service Engineer:</strong><br />
                        Gian Marco Occhibove &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <a href="mailto:g.occhibove@com-service.biz">g.occhibove@com-service.biz</a><br />
                        TEL. Diretto +39 346 2324142
                    </div>
                </div>

        <div className="footer-links">
          <span>Privacy Policy :</span>
          <Link to="/clienti" className="footer-link">Clienti</Link>
          <span className="footer-separator">/</span>
          <Link to="/fornitori" className="footer-link">Fornitori</Link>
          <span className="footer-separator">/</span>
          <Link to="/selezione-personale" className="footer-link">Selezione del Personale</Link>
        </div>
            </div>
        </div>
    );
};

export default Home;
